<template>
  <transition name="lucky-veil">
    <div v-if="visible" class="lucky-intro">
      <div class="lucky-stage">
        <p class="lucky-eyebrow">{{ $t('抢单.幸运订单') }}</p>
        <div class="lucky-rule" aria-hidden="true"></div>
        <h2 class="lucky-title">{{ $t('抢单.恭喜获得幸运订单') }}</h2>
        <p class="lucky-sub">{{ $t('抢单.幸运订单提示') }}</p>
        <p v-if="commission !== '' && commission !== null" class="lucky-commission">
          <span class="lucky-commission-label">{{ $t('抢单.佣金') }}</span>
          <span class="lucky-commission-value">{{ commission }}</span>
        </p>
        <button class="lucky-close" type="button" @click="finish">&times;</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LuckyOrderIntro',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    commission: {
      type: [String, Number],
      default: '',
    },
  },
  methods: {
    finish() {
      if (!this.visible) return
      this.$emit('done')
    },
  },
}
</script>

<style scoped>
.lucky-intro {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
  background:
    linear-gradient(180deg, rgba(31, 28, 31, 0.96) 0%, rgba(20, 17, 16, 0.98) 100%);
}

.lucky-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52%;
  height: 64px;
  margin: 48px auto 0;
  padding: 0;
  border: 0;
  border-radius: 32px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  box-shadow: 0 8px 18px rgba(220, 171, 118, 0.22);
  color: #68302c;
  font-size: 40px;
  font-weight: 400;
  line-height: 1;
  cursor: pointer;
  opacity: 0;
  animation: lucky-rise 0.75s ease 1.05s forwards;
}

.lucky-close:active {
  transform: scale(0.98);
}

.lucky-stage {
  width: 100%;
  max-width: 560px;
  text-align: center;
}

.lucky-eyebrow {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0.35em;
  text-indent: 0.35em;
  text-transform: uppercase;
  color: #a89278;
  opacity: 0;
  animation: lucky-rise 0.7s ease forwards;
}

.lucky-rule {
  width: 0;
  height: 1px;
  margin: 28px auto 32px;
  background: #766350;
  animation: lucky-rule 0.8s ease 0.2s forwards;
}

.lucky-title {
  margin: 0;
  font-size: 44px;
  font-weight: 600;
  line-height: 1.25;
  color: #f3c7a2;
  opacity: 0;
  animation: lucky-rise 0.75s ease 0.35s forwards;
}

.lucky-sub {
  margin: 20px 0 0;
  font-size: 26px;
  font-weight: 400;
  line-height: 1.55;
  color: #9b8a78;
  opacity: 0;
  animation: lucky-rise 0.75s ease 0.55s forwards;
}

.lucky-commission {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 48px 0 0;
  opacity: 0;
  animation: lucky-rise 0.75s ease 0.85s forwards;
}

.lucky-commission-label {
  font-size: 22px;
  color: #766350;
  letter-spacing: 0.12em;
}

.lucky-commission-value {
  font-size: 56px;
  font-weight: 600;
  line-height: 1;
  color: #e6b98a;
  font-variant-numeric: tabular-nums;
}

.lucky-veil-enter-active,
.lucky-veil-leave-active {
  transition: opacity 0.35s ease;
}
.lucky-veil-enter,
.lucky-veil-leave-to {
  opacity: 0;
}

@keyframes lucky-rise {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes lucky-rule {
  from { width: 0; }
  to { width: 72px; }
}
</style>
